import { GET_SERVICE, GET_OTP_TAXES } from './../constants';
import { handleActions } from "redux-actions"

export const taxes  = handleActions(
  {
    [ GET_SERVICE ]: (state, action) => {
      if (Object.keys(action.payload).length === 0) {
        return [ ...state ]
      } else {
        return [...state, action.payload]
      }
    },
    [ GET_OTP_TAXES ]: (state, action) => state
  }, []
)